import { defineComponent, h } from 'vue';
import { QDialog } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import UsercontrolBrowser from './usercontrolBrowser.jsx';
import DesignerRegistryMixin from './DesignerRegistryMixin.jsx';

export default defineComponent({
    name: 'dynamic-user-control-dsgn',
    mixins: [DesignerRegistryMixin],
    components: {
        QDialog,
        UsercontrolBrowser,
    },
    data: function () {
        return {
            control: {},
            pickervisible: false,
        }
    },
    created() {
        this.watcher$ = this.$watch('designmodel.ControlURL', function (val, oldval) {
            this.Refresh();
        });
    },
    unmounted() {
        this.watcher$();
    },  
    async mounted() {
        await this.Refresh();
    },
    props: {
        name: '',
        root: null,
        designmodel: null,
        controlData: null,
    },
    computed: {
        Root: function () {
            return this.root;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
    },
    methods: {
        ...methods,
        async Refresh()
        {
            if (this.designmodel.ControlURL) {
                try {
                    let c = await utils.api.get('Apps/UI/UserControl/' + this.designmodel.ControlURL);
                    if (!c)
                        c = await utils.api.get('Apps/UI/UserControl/public/' + this.designmodel.ControlURL);

                    this.control = c;
                }
                catch (e) {
                    this.control = {};
                }
            }
            else
                this.control = {};
        },
        SelectNode(node) {
            // Ignore node arg, we will only allow the designer to edit the control definition, not
            // individual members of a user control (because it is in a separate document)
            this.Root.SelectNode(this);
        },
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
        open(e) {
            this.Root.ExternalNavigateToName('UserControl', this.designmodel.ControlURL);

            e.cancelBubble = true;
            e.stopPropagation();
        },
        browse(e) {
            this.pickervisible = true;
            e.cancelBubble = true;
            e.stopPropagation();
        },
        confirm(name) {
            this.pickervisible = false;
            this.designmodel.ControlURL = name;
            this.Refresh();
        },
        cancel() {
            this.pickervisible = false;
        },
        pickerInput(value) {
            this.pickervisible = value;
        },
    },
    render() {
        if (!this.control.ControlData)
            return (
                <div
                    class={{ 'designer-container': true }}
                    style={{ minHeight: "40px", minWidth: "80px", border: "1px solid black" }}
                    onClick={(e) => this.handleClick(e)}>
                    <div class="design-options" title="Browse user controls" onClick={(e) => this.browse(e)} style={{ top: "4px", left: "44px", display: this.selected$ ? "block" : "none" }}>Browse</div>

                    <div class={{ "designer-user-control-hovering": true, 'designer-user-control-selected': this.selected$ }}></div>

                    <QDialog modelValue={this.pickervisible} onUpdate:modelValue={(value) => this.pickerInput(value)}>
                        <div style={{ width: '860px', maxWidth: '90vw', overflow: 'hidden' }}>
                            <UsercontrolBrowser confirm={this.confirm} cancel={this.cancel}></UsercontrolBrowser>
                        </div>
                    </QDialog>
                </div>
            );

        let DynamicControl = utils.getDesignerComponent(this.control);

        const open_title = "Open " + this.designmodel.ControlURL;

        return (
            <div
                class={{ 'designer-container': true }}
                style={{ minHeight: "40px", minWidth: "80px", border: "1px solid black" }}
                onClick={(e) => this.handleClick(e)}>
                <div class="design-options" title={open_title} onClick={(e) => this.open(e)} style={{ top: "4px", left: "4px", display: this.selected$ ? "block" : "none" }}>Open</div>
                <div class="design-options" title="Browse user controls" onClick={(e) => this.browse(e)} style={{ top: "4px", left: "44px", display: this.selected$ ? "block" : "none" }}>Browse</div>

                <div class={{ "designer-user-control-hovering": true, 'designer-user-control-selected': this.selected$ }}></div>
                <DynamicControl type={this.control.ControlType} name={this.control.ControlData.Name} root={this} controlData={this.control.ControlData}>
                </DynamicControl>

                <QDialog modelValue={this.pickervisible} onUpdate:modelValue={(value) => this.pickerInput(value)}>
                    <div style={{ width: '860px', maxWidth: '90vw', overflow: 'hidden' }}>
                        <UsercontrolBrowser confirm={this.confirm} cancel={this.cancel}></UsercontrolBrowser>
                    </div>
                </QDialog>
            </div>
        );
    }
});

